import { z } from "zod";

export const MIN_NUTRITION_GENERATION_CALORIES = 1000;
export const nutritionGenerationCaloriesSchema = z.number().min(MIN_NUTRITION_GENERATION_CALORIES, {
  message: `Cel dzienny musi wynosić co najmniej ${MIN_NUTRITION_GENERATION_CALORIES} kcal`,
});

const MACRO_SUM_TOLERANCE = 0.1;
const percentageSchema = z.number().min(0).max(100);

export const nutritionMacroTargetsSchema = z
  .object({
    protein: percentageSchema,
    carbs: percentageSchema,
    fat: percentageSchema,
    gender: z.string().optional(),
  })
  .refine((targets) => Math.abs(targets.protein + targets.carbs + targets.fat - 100) <= MACRO_SUM_TOLERANCE, {
    message: "Suma procentów makroskładników musi wynosić 100%",
  });

export const nutritionV3TargetsSchema = z.object({
  targetCalories: nutritionGenerationCaloriesSchema,
  mealsSchema: z.union([z.string(), z.number()]).refine((value) => [2, 3, 4, 5, 6].includes(Number(value)), {
    message: "Wybierz od 2 do 6 posiłków dziennie",
  }),
  dietaryPreference: z.union([z.string(), z.number()]).refine((value) => [1, 2, 3, 4].includes(Number(value))),
  targets: nutritionMacroTargetsSchema,
});
